import XTableNamer from "./XTableNamer.js";
import * as Excel from "exceljs/dist/exceljs.min.js";

import {
  saveAs
} from 'file-saver'

/**
 * Exceldownload working with NSWOW2 Tables
 */
class XDownloader {
  constructor(config = {}) {
    const {
      downloadText, // Text for downloadbutton, can be empty if you want to use an icon
      backgroundColor, // Color
      borderColor,
      borderColor2,
      borderStyle, // thin/dotted/medium/double/thick
      borderStyle2, // thin/dotted/medium/double/thick
      headClass,
      boldClass,
      boldClass2,
      backgroundClass,
      borderClass,
      borderClass2
    } = config;

    const env = this.getEnvironement();
    this.downloadText = downloadText || 'Download Excel'; //Text on button, can be empty
    this.backgroundColor = backgroundColor || 'ecf0f1';
    this.borderColor = borderColor || '34495e';
    this.borderColor2 = borderColor2 || '34495e';
    this.borderStyle = borderStyle || 'thin';
    this.borderStyle2 = borderStyle2 || 'thin';
    this.headClass = headClass || 'head';
    this.boldClass = boldClass || 'bold';
    this.boldClass2 = boldClass2 || 'bold';
    this.backgroundClass = backgroundClass || 'bold';
    this.borderClass = borderClass || 'border-bottom';
    this.borderClass2 = borderClass2 || 'border-bottom';

    this.mergeStrings = [];

    const tables = Array.prototype.slice.call(document.querySelectorAll('.ns-table-wrap'));

    new XTableNamer();

    tables.forEach(table => {
      if(this.checkTable(table)){
        this.addLink(table);
      } else if( env === 'stage' ){
        this.addLink(table, true);
      }
    });
  }

  checkTable(table){
    const TDs = Array.prototype.slice.call( table.querySelectorAll('tr:first-child > td') );
    let rt = true;
    TDs.forEach( td => {
      //console.log(!td.classList.contains('excel-download') && !td.classList.contains(this.headClass))
      if(td.colSpan > 1 ) rt = false;
      if((!td.classList.contains('excel-download') && !td.classList.contains(this.headClass))) rt = false;
    } );
    return rt;
  }

  createWorkbook(table) {
    this.name = table.querySelector('[data-tableid]').dataset.tableid //if you have an error on this line replace data-tableid with data-table-id & tableid to tableId
    const workbook = new Excel.Workbook();
    this.worksheet = workbook.addWorksheet(this.name);
    this.mergeStrings = [];
    try{
      this.parseTable(table);
      this.parseFootnote(table);
      this.mergeCells(table);
      this.saveFile(this.getFileTitle(table)+'.xlsx', workbook);
    } catch(err){
      this.sendAlert();
    }
  }

  mergeCells(table){
    this.worksheet.mergeCells('A3:Z3');

    this.mergeStrings.forEach(s => {
      this.worksheet.mergeCells(s);
    });
  }

  /**
   * This one parses the footnotes and puts it after the table content in the worksheet
   * @param {*} table
   */
  parseFootnote(table) {
    const footnotes = Array.prototype.slice.call(table.querySelectorAll('p.ns-footnote'));
    this.worksheet.addRow([]);
    footnotes.forEach(fn => {
      this.worksheet.addRow([fn.innerText.replace('\n', ' ')]);
    });
  }

  getFileTitle(elem) {
    return elem.dataset.xFileTitle;
  }
  getTitle(elem) {
    return elem.dataset.xTitle;
  }

  /**
   * This one parses the table and puts it into the worksheet
   * @param {*} table
   */
  parseTable(table) {


    const t = table.querySelector('table');
    const rows = Array.prototype.slice.call(t.querySelectorAll('tr'));
    let row;
    let content = [];

    let counterR = 0;
    let counterC = 0;

    const title = this.getTitle(table);

    let styles = [];
    let first = true;

    rows.forEach(r => {
      counterR++; //counters to keep track where you are
      counterC = 0;
      content = [];

      const tds = Array.prototype.slice.call(r.querySelectorAll('td'));
      if(first){
        if (r.classList.contains('excel-download') || r.classList.contains(this.headClass)) {
          first = false;

          tds.forEach(t => { //first iteration for header column without content to set widths of columns
            counterC++;

            content.push({
              header: ' ',
              key: 'id',
              width: t.offsetWidth / 7
            });

          });
          this.worksheet.columns = content;

          counterC = 0;
          counterR++;
          content = [];

          row = this.worksheet.lastRow;
          row.height = 0.5;

          if(title){
            this.worksheet.addRow([title]);
            row = this.worksheet.lastRow;

            row.getCell('A').font = {
              size: 16,
              bold: true
            };

            this.worksheet.addRow([]);
          }
        }
      }


      tds.forEach(t => { //second iteration for actual content
        counterC++;

        styles[counterC] = this.getStyles(t); // get styles based on classes of the td

        let c = this.correct(t.innerText);

        if (isNaN(c)) {
          c = c;
        } else {

          if (c == '\u00A0' || c.trim() == '') { //apparently this is still considered not NaN
            c = c;
          } else {
            c = parseFloat(c);
          }
        }
        content.push(c);
        const colspan = parseInt(styles[counterC]['colspan']);
        if(colspan > 1){
          for (let i = 1; i < colspan; i++) {
            content.push('');
            counterC++;
          }
        }
      });

      this.worksheet.addRow(content);

      row = this.worksheet.lastRow;

      //go through the styles array and apply the styles
      for (let i = 1; i < (styles.length + 1); i++) {
        if (!!styles[i]) {
          if (!!styles[i]['align']) {
            row.getCell(i).alignment = styles[i]['align'];
          }
          if (!!styles[i]['border']) {
            row.getCell(i).border = styles[i]['border'];
          }
          if (!!styles[i]['font']) {
            row.getCell(i).font = styles[i]['font'];
          }
          if (!!styles[i]['fill']) {
            row.getCell(i).fill = styles[i]['fill'];
          }
          let colspan = parseInt(styles[i]['colspan']);
          if (colspan > 1) {
            const mergeString = this.getLetter(i) + (counterR + 2) + ':' + this.getLetter(i + colspan - 1) + (counterR + 2);
            this.mergeStrings.push(mergeString);
          }
        }
      }
    });

  }

  /**
   * check for classes and return the right styles
   * can be extended
   * @param {*} t
   */
  getStyles(t) {
    const r = [];

    r['colspan'] = t.colSpan;

    if(t.classList.contains('ns-horizontal-left')){
      r['align'] = { horizontal: 'left',  wrapText: true }
    }
    if(t.classList.contains('ns-horizontal-right')){
      r['align'] = { horizontal: 'right',  wrapText: true }
    }
    if(t.classList.contains('ns-horizontal-center')){
      r['align'] = { horizontal: 'center',  wrapText: true }
    }

    if (t.classList.contains(this.backgroundClass)) {
      r['fill'] = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          argb: 'FF'+this.backgroundColor
        }
      };
    } else { //if there's no background we return white background because it makes the excel prettier
      r['fill'] = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: {
          rgb: 'FFFFFFFF'
        }
      };
    }

    if (t.classList.contains(this.colorClass) || t.classList.contains(this.boldClass) ||t.classList.contains(this.boldClass2) || t.classList.contains(this.headClass)) {
      r['font'] = {
        bold: true
      };
    } else{
      r['font'] = {};
    }


    if (t.classList.contains(this.borderClass)) {
      r['border'] = {
        bottom: {
          style: this.borderStyle,
          color: {
            argb: 'FF'+this.borderColor
          }
        }
      };
    } else if(t.classList.contains(this.borderClass2)){
      r['border'] = {};
    }
    else {
      r['border'] = {
        bottom: {
          style: this.borderStyle2,
          color: {
            argb: 'FF'+this.borderColor2
          }
        }
      };
    }

    return r;
  }


 /**
  * yeah well, add the fucking link to the table, this one doesnt need explanation
  * @param {*} table
  */
  addLink(table, error) {
    let link = document.createElement('a');
    link.classList.add('exceldl-link');
    if(error) link.classList.add('error');
    link.innerText = this.downloadText;
    link.href = '#';

    table.prepend(link);

    link.addEventListener('click',
      (e) => {
        e.preventDefault();
        if(link.classList.contains('error')){
          this.sendAlert();
        } else{
          this.createWorkbook(table);
        }
      });
  }

  /**
   * savefile doesnt need explanation as well
   * @param {*} fileName
   * @param {*} workbook
   */
  async saveFile(fileName, workbook) {
    const xls64 = await workbook.xlsx.writeBuffer({
      base64: true
    })
    saveAs(
      new Blob([xls64], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      }),
      fileName
    )
  }

  /**
   * delete the thousand marks and replace false minus with right one
   */
  correct(text) {
    return text.replace(/'/g, '').replace(/(?:\r\n|\r|\n)/g, '\n').replace(/’/g, '').replace(/–/g, '-').replace(/'/g, '.').replace(/–/g, '-').replace(/,/g, '.');
  }

  getLetter(number){
    const letters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
    return letters[number-1];
  }

  getEnvironement(){
    const body = document.querySelector('body');
    if(body.classList.contains('wp-production')){
      return 'production';
    } else{
      return 'stage';
    }
  }

  sendAlert(){
    alert(`Die Tabelle hat verbundene Zellen in der ersten Reihe, das wird nicht unterstützt vom XDownloader.
Falls verbundene Zellen in der ersten Reihe benötigt werden bitte erste Zeile leer mit der Klasse .excel-download erfassen.
Darüber hinaus muss die erste Reihe entweder die Klasse .excel-download oder .${this.headClass} haben.` );
  }

}
export default XDownloader;
